/** UA anchoring не должно конкурировать с ручным восстановлением позиции. */
interface AnchorStyle {
  getPropertyValue(name: string): string
  getPropertyPriority(name: string): string
  setProperty(name: string, value: string, priority?: string): void
  removeProperty(name: string): string
}

export function createScrollAnchoringLock(target: () => AnchorStyle | null) {
  let held = 0
  let saved: { style: AnchorStyle; value: string; priority: string } | undefined
  return {
    lock(): () => void {
      if (held === 0) {
        const style = target()
        if (style) {
          saved = {
            style,
            value: style.getPropertyValue('overflow-anchor'),
            priority: style.getPropertyPriority('overflow-anchor'),
          }
          style.setProperty('overflow-anchor', 'none', saved.priority)
        }
      }
      held += 1
      let released = false
      return () => {
        if (released) return
        released = true
        held -= 1
        if (held !== 0 || !saved) return
        const { style, value, priority } = saved
        saved = undefined
        // Не перезаписываем явную смену стиля другим владельцем.
        if (style.getPropertyValue('overflow-anchor') !== 'none') return
        if (value) style.setProperty('overflow-anchor', value, priority)
        else style.removeProperty('overflow-anchor')
      }
    },
    count: () => held,
  }
}
